/**
 * Returns the actual axis string
 * @param {TriggerProps} trigger
 * @returns {String}
 */
const getAxisValue = (trigger) => {
  /** "Axis" parameter of the trigger */
  const pAxis = /** @type {TriggerParameterTypeProps} */ (
    trigger.get("p_axis")
  );

  /** Axis */
  return /** @type {String} */ (pAxis.get("value"));
};

export default getAxisValue;
